import {AxiosInstance, AxiosResponse} from 'axios';

export interface IAdminApi {
    getPatients<T>(): Promise<AxiosResponse<T>>;
}

export default class AdminApi implements IAdminApi {
    private readonly _axiosInstance;
    private readonly _controller = 'admin';

    constructor(axiosInstance: AxiosInstance) {
        this._axiosInstance = axiosInstance;
    }

    async getPatients<T>(): Promise<AxiosResponse<T>> {
        return await this._axiosInstance.get<T>(`${this._controller}/patients`);
    }
}
